<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<path
				class="regular"
				d="M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l95.4 74.8C182 29.5 248.9 0 320 0c91.5 0 176 48.8 221.7 128s45.7 176.8 0 256c-2 3.5-4.1 6.9-6.3 10.3l95.4 74.8c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM82.3 160.9L142.2 208l-24.6 0c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48c0-2.9 0-5.7 .1-8.6L241 285.9c.4 6.2 .9 12.2 1.5 18.1l21.5 0 60.9 48-74.5 0c5.6 24.4 13.2 45.9 22 63.6C293 456.8 312.6 464 320 464s27-7.2 47.6-48.4c3.4-6.9 6.7-14.4 9.7-22.3l39.1 30.8c-3.3 7.5-6.7 14.6-10.4 21.3l.1 0c7.7-3.5 15.1-7.5 22.3-11.9l39.7 31.3C425.5 495 374 512 320 512c-91.5 0-176-48.8-221.7-128c-39.6-68.6-44.9-150.9-16-223.1zM135.4 352c21.4 41.1 56.1 74.1 98.4 93.4c-14-25.6-25.2-57.5-32.5-93.4l-65.9 0zm36.8-242.4l34.5 27c7-26.4 16.2-50.1 27.2-70.1c-23.1 10.6-44 25.2-61.6 43zM250.4 160l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C347 55.2 327.4 48 320 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm47.3 48l101.3 79.4c.7-10.2 1.1-20.7 1.1-31.4c0-16.6-.9-32.7-2.5-48l-99.8 0zM406.1 66.6c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0-.1 0c-21.4-41.1-56.1-74.1-98.4-93.4zM445.7 208c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48l76.7 0c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48l-76.7 0zm35.7 144l16 12.5c2.5-4.1 4.9-8.3 7.1-12.5l-23.1 0z"
			/>
		</svg>
	</Icon>
</template>

<script setup>
import Icon, { props, types } from './Icon'

defineOptions({ name: 'GlobeSlashIcon' })
defineProps({
	...props,
	type: {
		...props.type,
		default: types.REGULAR,
	},
})
</script>

<style scoped lang="scss">
@import 'src/sass/variables';

.pronto-icon {
	@include flex-center;
	width: 1.5em !important;
	svg {
		width: 1.5em !important;
		margin-left: -0.5em !important;
	}
}
</style>
